import { ArticleBody } from './ArticleBody.jsx';
import { ArticleHeader } from './ArticleHeader.jsx';

const theme = {
  leftMargin: 13,
  rightMargin: 23,
  gutterWidth: 4,
  contentWidth: 56,
  verticalSpace: 1.25,
  mobileGutter: 18,
};

export function Article({ children, headline, leadText = null }) {
  return (
    <article className="root">
      <ArticleHeader headline={headline} leadText={leadText} theme={theme} />
      <ArticleBody content={children} theme={theme} />
      <style jsx>{`
        @media screen and (min-width: 750px) {
          .root {
            max-width: 1200px;
            margin-right: auto;
            margin-left: auto;
          }
        }
      `}</style>
    </article>
  );
}
